import httpClient from '@uc/httpClient'
import Auth from 'services/auth'
import LocalStorage from 'helpers/browserStorage/LocalStorage'
import router from '@/router'

export default {
  initialLogin: initialLogin,
  getAccessTokenFromIS: getAccessTokenFromIS,
  setAccessToken: setAccessToken
}

async function initialLogin () {
  let accessToken = LocalStorage.get('accessToken')
  console.log('accessToken from localStorage...', accessToken)

  if (!accessToken) {
    await getAccessTokenFromIS()
  } else {
    setAccessToken(accessToken)
  }
}

async function getAccessTokenFromIS () {
  try {
    let response = await Auth.getAccessToken()
    console.log('getAccessTokenFromIS response...', response.data.access_token)
    setAccessToken(response.data.access_token)
  } catch (error) {
    router.push('/503')
  }
}

function setAccessToken (accessToken) {
  LocalStorage.set('accessToken', accessToken)
  httpClient.setDefaultHeaders('Authorization', 'Bearer ' + accessToken)
}



// WEBPACK FOOTER //
// ./src/helpers/AccessTokenHelper.js